module.exports = __webpack_public_path__ + "img/gb@2x.39f407fd.png";